import { useState } from "react";
import { Check, ChevronsUpDown, Scale } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Command, CommandEmpty, CommandInput, CommandItem, CommandList } from "@/components/ui/command";
import { COUNTRIES, countryByCode, jurisdictionLabel } from "@/constants/countries";

export const CountryCombobox = ({ value, onChange, labelClass }) => {
  const [open, setOpen] = useState(false);
  const selected = countryByCode(value);
  return (
    <div>
      <span className={labelClass} id="country-label">Base country <span className="text-rose-300">*</span></span>
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>
          <button type="button" role="combobox" aria-expanded={open} aria-labelledby="country-label"
            className="flex w-full items-center justify-between gap-2 rounded-xl border border-white/10 bg-[#060913]/70 px-3.5 py-2.5 text-left text-sm text-white transition-[border-color] hover:border-cyan-400/50"
            data-testid="intake-country-trigger">
            <span className={`truncate ${selected ? "" : "text-slate-500"}`}>{selected ? `${selected.flag} ${selected.name}` : "Search and select your base country…"}</span>
            <ChevronsUpDown className="h-4 w-4 shrink-0 text-slate-400" aria-hidden="true" />
          </button>
        </PopoverTrigger>
        <PopoverContent className="w-[var(--radix-popover-trigger-width)] border-white/10 bg-[#0B1021] p-0" align="start">
          <Command className="bg-transparent">
            <CommandInput placeholder="Type a country…" data-testid="intake-country-search" />
            <CommandList className="noscrollbar max-h-64">
              <CommandEmpty>No country found.</CommandEmpty>
              {COUNTRIES.map((c) => (
                <CommandItem key={c.code} value={`${c.name} ${c.code}`} onSelect={() => { onChange(c.code); setOpen(false); }}
                  data-testid={`intake-country-option-${c.code}`}>
                  <span className="mr-2">{c.flag}</span>
                  <span className="flex-1 truncate">{c.name}</span>
                  {value === c.code && <Check className="h-4 w-4 text-cyan-300" aria-hidden="true" />}
                </CommandItem>
              ))}
            </CommandList>
          </Command>
        </PopoverContent>
      </Popover>
      {selected && (
        <p className="mt-2 inline-flex items-center gap-1.5 rounded-full border border-blue-400/30 bg-blue-500/10 px-2.5 py-1 text-[11px] font-semibold text-blue-200" data-testid="intake-jurisdiction-chip">
          <Scale className="h-3 w-3" aria-hidden="true" /> {jurisdictionLabel(value)}
        </p>
      )}
    </div>
  );
};
